var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Chamsocxe = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "careOrange",
    x1: 24,
    y1: 6.5,
    x2: 24,
    y2: 19.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "washCarBlue",
    x1: 9.79874,
    y1: 21.75,
    x2: 38.2012,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "careClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#careClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 39,
    rx: 13.8,
    ry: 2.8,
    fill: "#D8E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 8.1C29.2 7.91 29.07 7.74 28.88 7.68L24.25 6.29C24.09 6.24 23.91 6.24 23.75 6.29L19.12 7.68C18.93 7.74 18.8 7.91 18.8 8.1V12.68C18.8 16 20.82 18.61 24 19.83C27.18 18.61 29.2 16 29.2 12.68V8.1Z",
    fill: "url(#careOrange)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9.46C24.31 9.46 24.56 9.71 24.56 10.02V12.07H26.62C26.93 12.07 27.18 12.32 27.18 12.63C27.18 12.94 26.93 13.19 26.62 13.19H24.56V15.24C24.56 15.55 24.31 15.8 24 15.8C23.69 15.8 23.44 15.55 23.44 15.24V13.19H21.38C21.07 13.19 20.82 12.94 20.82 12.63C20.82 12.32 21.07 12.07 21.38 12.07H23.44V10.02C23.44 9.71 23.69 9.46 24 9.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.7L14.65 13.63L15.58 13.98L14.65 14.33L14.3 15.26L13.95 14.33L13.02 13.98L13.95 13.63L14.3 12.7Z",
    fill: "#FFB85B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 13.9L34.08 14.92L35.1 15.3L34.08 15.68L33.7 16.7L33.32 15.68L32.3 15.3L33.32 14.92L33.7 13.9Z",
    fill: "#FFB85B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.95 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1594 35.5489L22.6505 36.6203H31.2487L30.7773 35.5489H23.1594Z",
    fill: "url(#washCarBlue)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1327 30.5505C37.8561 29.4678 36.2765 28.6362 35.6632 27.9254L36.5792 27.9255C36.8993 27.9219 37.2052 27.7922 37.4303 27.5645C37.6555 27.3369 37.7818 27.0296 37.7818 26.7094C37.7818 26.3892 37.6555 26.0819 37.4303 25.8542C37.2052 25.6265 36.8993 25.4969 36.5791 25.4933C36.0252 25.5211 34.9334 25.3855 34.447 25.6755C33.6898 24.1361 33.5459 21.7192 31.4417 21.7005L22.4416 21.7005C20.348 21.7164 20.1911 24.1354 19.4363 25.6755C18.9459 25.3812 17.8479 25.5253 17.3042 25.4933C16.9816 25.4933 16.6723 25.6215 16.4443 25.8495C16.2162 26.0776 16.0881 26.3869 16.0881 26.7094C16.0881 27.0319 16.2162 27.3413 16.4443 27.5693C16.6723 27.7974 16.9816 27.9255 17.3042 27.9255H18.2202C17.7488 28.3701 17.0149 29.013 16.3399 29.5755C16.1344 29.7617 15.9705 29.9892 15.8588 30.243C15.7471 30.4969 15.6902 30.7714 15.6917 31.0487V34.4933C15.6931 34.9422 15.8356 35.3792 16.099 35.7426C16.3625 36.106 16.7334 36.3774 17.1595 36.5183C17.4954 36.7035 21.0186 36.5932 21.4614 36.6201L22.3346 34.7826C22.3782 34.6916 22.4465 34.6147 22.5318 34.5607C22.617 34.5067 22.7158 34.4778 22.8167 34.4773H31.1256C31.2287 34.4773 31.3296 34.5072 31.4161 34.5633C31.5026 34.6194 31.571 34.6993 31.6131 34.7933L32.4167 36.6201H36.0703C36.6329 36.617 37.1715 36.3917 37.5688 35.9934C37.9661 35.5951 38.19 35.0559 38.1917 34.4933C38.1976 34.1508 38.2286 30.7875 38.1327 30.5505ZM19.1149 31.6648H17.5774C17.437 31.6622 17.3031 31.6047 17.2047 31.5045C17.1063 31.4043 17.0512 31.2695 17.0512 31.129C17.0512 30.9886 17.1063 30.8538 17.2048 30.7536C17.3032 30.6534 17.437 30.5958 17.5774 30.5933H19.1149C19.2556 30.5953 19.39 30.6526 19.4888 30.7529C19.5877 30.8531 19.6431 30.9883 19.6431 31.129C19.6431 31.2698 19.5877 31.405 19.4888 31.5052C19.39 31.6055 19.2556 31.6628 19.1149 31.6648ZM32.6309 31.6648H21.2577C21.1157 31.6648 20.9794 31.6083 20.8789 31.5079C20.7785 31.4074 20.722 31.2711 20.722 31.129C20.722 30.987 20.7785 30.8507 20.8789 30.7502C20.9794 30.6498 21.1157 30.5933 21.2577 30.5933H32.6309C32.7717 30.5954 32.9059 30.6528 33.0047 30.753C33.1034 30.8533 33.1588 30.9883 33.1588 31.1291C33.1588 31.2698 33.1034 31.4048 33.0046 31.5051C32.9059 31.6053 32.7717 31.6627 32.6309 31.6648ZM19.7792 27.6523C19.7845 27.6469 21.2952 23.8701 21.472 23.4148C21.5525 23.2241 21.6874 23.0614 21.8599 22.9471C22.0323 22.8327 22.2347 22.7718 22.4417 22.7719H31.4417C31.6467 22.7712 31.8474 22.8307 32.0188 22.9431C32.1903 23.0555 32.3249 23.2158 32.406 23.4041C32.5774 23.8487 34.0988 27.6469 34.1042 27.6523L19.7792 27.6523ZM36.306 31.6648H34.7738C34.6334 31.6622 34.4996 31.6047 34.4012 31.5045C34.3027 31.4043 34.2476 31.2695 34.2476 31.129C34.2476 30.9886 34.3028 30.8538 34.4012 30.7536C34.4996 30.6534 34.6334 30.5958 34.7738 30.5933H36.3059C36.4467 30.5953 36.581 30.6526 36.6799 30.7529C36.7787 30.8531 36.8341 30.9883 36.8341 31.1291C36.8341 31.2698 36.7787 31.405 36.6799 31.5052C36.581 31.6055 36.4467 31.6628 36.306 31.6648Z",
    fill: "url(#washCarBlue)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8435 37.5415C16.5787 37.4514 16.3252 37.331 16.0881 37.1826V37.6701C16.0881 37.8446 16.1224 38.0174 16.1892 38.1786C16.2559 38.3398 16.3538 38.4862 16.4772 38.6096C16.6005 38.733 16.747 38.8309 16.9082 38.8976C17.0694 38.9644 17.2422 38.9987 17.4167 38.9987H19.2649C19.6137 38.999 19.9485 38.8621 20.1972 38.6175C20.4458 38.3729 20.5881 38.0403 20.5935 37.6915C19.8557 37.6522 17.5201 37.8098 16.8435 37.5415Z",
    fill: "url(#washCarBlue)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2898 37.6915C33.2952 38.0403 33.4375 38.3729 33.6861 38.6175C33.9348 38.8621 34.2696 38.999 34.6184 38.9987H36.4666C36.6411 38.9987 36.8139 38.9644 36.9751 38.8976C37.1363 38.8309 37.2828 38.733 37.4061 38.6096C37.5295 38.4862 37.6274 38.3398 37.6941 38.1786C37.7609 38.0174 37.7952 37.8446 37.7952 37.6701V37.1826C37.2811 37.5147 36.6822 37.6914 36.0702 37.6915H33.2898Z",
    fill: "url(#washCarBlue)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Chamsocxe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2chamsocxe.1c194033.svg";
export { ForwardRef as ReactComponent };